import { Component, ChangeDetectorRef, ChangeDetectionStrategy, Input, OnDestroy } from '@angular/core';
import { BaseComponent } from '../base-component';
import { Expedition } from '../comun/recipient-services/expedition';
import { TransitEvent } from '../comun/recipient-services/transit-event';

@Component({
  selector: 'tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrackingComponent extends BaseComponent {

  resources: any = {};

  constructor(private cdr: ChangeDetectorRef) {
    super();
  }

  onInitializedSharedResources() {
    this.cdr.detectChanges();
  }

  @Input() tracking = new Array<TransitEvent>();

}
